export const canIAccess = (role, resource, action) => {
  const blackListsRoutes = [
    'admin-training-schedule',
    'admin-training-schedule-us',
    'admin-training-schedule-eu',
    'admin-customers',
    'admin-contacts',
    'admin-notifications',
    'admin-sales-reps',
  ];

  const blackListsRoles = ['tech'];

  const allowedAccess = {
    tech: {
      'admin-training-schedule': [],
      'admin-training-schedule-us': [],
      'admin-training-schedule-eu': [],
      'admin-customers': [],
      'admin-contacts': ['update'],
      'admin-notifications': [],
    },
  };

  const actions = {
    create: [...blackListsRoutes],
    update: [...blackListsRoutes],
    delete: [...blackListsRoutes],
  };

  return (
    (allowedAccess[role] &&
      allowedAccess[role][resource] &&
      allowedAccess[role][resource].includes(action)) ||
    !(blackListsRoles.includes(role) && actions[action].includes(resource))
  );
};
